import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import "../css/hireme.css";
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Otpvalidation from "./Otpvalidation";
import { useState } from 'react';

import axios from 'axios';
export default function HireMe(){
    const [name,setname]=useState();
    const [email,setemail]=useState();
    const [mobile,setmobile]=useState();
    const [about,setabout]=useState();
    const [loading,setloading]=useState(false);
    const [nameerror,setnameerror]=useState(false);
    const [emailerror,setemailerror]=useState(false);
    const [abouterror,setabouterror]=useState(false);
    const [errortext,seterrortext]=useState("");
    const [otp,setotp]=useState(false);
    const [error,seterror]=useState(false);
    const [reserror,setreserror]=useState(false);
    async function handleClick(){
            setloading(true);
            setnameerror(false);
            setemailerror(false);
            setreserror(false);
            setabouterror(false);
            seterror(false);
            if(!name || !email || !about ){
                if(!name)
                setnameerror(true);
                if(!email)
                setemailerror(true);
                if(!about)
                setabouterror(true);
                setloading(false);
                return;
            }
            try {
                const res=await axios.post(`${process.env.REACT_APP_NODEJS}/otp`,{email}) ;
           
                if(res.data.error){
                  setemailerror(true);
                 seterrortext(res.data.error);
                 seterror(true);
                }else{
                    setotp(true);
                }
            } catch (error) {
                console.log(error);
                setreserror(true);
            }
            setloading(false);
    }
    return(
        <div id='hireme'>
    {  otp?<Otpvalidation name={name} email={email} mobile={mobile} about={about}  />:<Box sx={{display:"flex",flexDirection:"column",rowGap:"20px",width:"25vw",transform:"translate(30vw,18vh)",backdropFilter:"blur(15px)"}}>
            <TextField id="standard-basic" label="Enter your name" variant="standard" required onChange={(e)=>setname(e.target.value)} error={nameerror} />
             <TextField id="standard-basic" label="Valid email id " variant="standard" required onChange={(e)=>setemail(e.target.value)}  error={emailerror}/>
          <TextField id="standard-basic" label="Enter Mobile Number with country Code" variant="standard"  onChange={(e)=>setmobile(e.target.value)} />
           <TextField id="outlined-basic" label="briefly describe your project" variant="outlined"  required multiline  onChange={(e)=>setabout(e.target.value)}  error={abouterror} maxRows="5" />
           <Button variant="contained" onClick={handleClick} disabled={loading}>
  Proceed to verify email
</Button>
{error && <Alert severity="error">{errortext}</Alert>}
{
    reserror  &&
    <Alert severity="error">Something went wrong,try again</Alert>
}
        </Box>
}

<div id='hireme_background'>
    <Box sx={{display:"flex"}}>
    <img src='https://media-public.canva.com/6fP2U/MAEpy06fP2U/1/s.png' alt='svg' />
    
    <img src='https://media-public.canva.com/fF40I/MAE1mefF40I/1/s.png' alt='svg' />
    </Box>
</div>
        </div>
    );
}